// Funcionalidade pins
export class PinMapHandler {
    constructor(controller) {
        this.controller = controller
        this._map = null
        this._marker = null
    }

    init() {
        if (!this.controller.hasMapTarget) return

        const mapOptions = {
            zoom: this.controller.latValue && this.controller.lngValue ? 10 : 4,
            center: this.controller.latValue && this.controller.lngValue
                ? { lat: this.controller.latValue, lng: this.controller.lngValue }
                : { lat: -14, lng: -55 }
        }

        this._map = new google.maps.Map(this.controller.mapTarget, mapOptions)

        if (this.controller.latValue && this.controller.lngValue && this.controller.modeValue !== 'edit') {
            new google.maps.Marker({
                position: { lat: this.controller.latValue, lng: this.controller.lngValue },
                map: this._map
            })
        }

        if (this.controller.modeValue === 'edit' || !this.controller.latValue || !this.controller.lngValue) {
            this._map.addListener('click', this.controller.onMapClick.bind(this.controller))
        }
    }

    handleClick(event) {
        if (this._marker) {
            this._marker.setMap(null)
        }

        this._marker = new google.maps.Marker({
            position: event.latLng,
            map: this._map,
            draggable: true
        })

        if (this.controller.hasLatTarget) this.controller.latTarget.value = event.latLng.lat()
        if (this.controller.hasLngTarget) this.controller.lngTarget.value = event.latLng.lng()
    }
}